// extracted by mini-css-extract-plugin
export default {"empty":"empty_empty__3cYro","empty__title":"empty_empty__title__3Jcpp","empty__description":"empty_empty__description__b30-S"};